export const NOTIFY_ALERT_SET_ITEMS = '@notify.alert.set.items';
